import React, { useState, useEffect } from 'react';
import API from '../../../pages/Api';
import { toast } from 'react-toastify';
import { FaTrash } from 'react-icons/fa';
import TableContainer from '../../common/Tablecontainer'; // 💡 Reuses your common logic properties framework cleanly

const EnquiryDetails = () => {
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [list, setList] = useState([]);
    const [loadingCards, setLoadingCards] = useState(false);
    const [mobilePage, setMobilePage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);

    const pageSize = 10;
    const loadCustomerEnquiryLogs = async (
        page = 1,
        search = searchQuery
    ) => {

        try {

            setLoadingCards(true);

            const res = await API.get(
                "admin/enquiry-details/",
                {
                    params: {
                        page,
                        search
                    }
                }
            );

            if (res.data.results) {

                setList(res.data.results);
                setTotalCount(res.data.count);

            } else {

                setList(res.data);
                setTotalCount(res.data.length);

            }

        } catch (err) {

            console.error(err);

            setList([]);
            setTotalCount(0);

        } finally {

            setLoadingCards(false);

        }

    };

    useEffect(() => {

        const timer = setTimeout(() => {

            loadCustomerEnquiryLogs(
                mobilePage,
                searchQuery
            );

        }, 400);

        return () => clearTimeout(timer);

    }, [mobilePage, searchQuery]);

    const handleRecordDeleteTrigger = async (pk, refreshTable) => {
        if (!window.confirm("Are you sure you want to permanently clear this customer enquiry?")) return;
        try {
            const res = await API.delete(`admin/enquiry-details/${pk}/`);
            if (res.status === 200) {
                toast.success("Enquiry record purged successfully.");
                await loadCustomerEnquiryLogs(
                    mobilePage,
                    searchQuery
                );

                if (refreshTable) {
                    refreshTable();
                }
            }
        } catch (err) {
            console.error("Failure processing delete entity:", err);
            toast.error("Deletion failed.");
        }
    };

    // Filters row fields data matching keywords text logic parameter boundaries safely
    // const filteredEnquiries = enquiries.filter(item => 
    //     item.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //     item.email?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //     item.remarks?.toLowerCase().includes(searchQuery.toLowerCase())
    // );
    const ExpandedRemarksCell = ({ text }) => {
        const [isExpanded, setIsExpanded] = React.useState(false);

        if (!text) return <span>null</span>;

        // 💡 Check if string length or lines require truncation threshold limits
        const shouldTruncate = text.length > 90; 

        return (
            <div className="p-3 w-full min-w-0 text-left pl-5 font-normal text-gray-600 normal-case leading-relaxed text-justify">
                {/* 💡 FIX: Replicated the exact 2-lines line-clamp preview boundary layer layout natively */}
                <div className={!isExpanded && shouldTruncate ? "line-clamp-2 overflow-hidden" : "whitespace-pre-wrap break-all"}>
                    {text}
                </div>
                
                {shouldTruncate && (
                    <button
                        type="button"
                        onClick={() => setIsExpanded(!isExpanded)}
                        className="mt-1 text-blue-600 hover:text-blue-900 font-bold bg-transparent border-none cursor-pointer text-[11px] block tracking-normal transition-all duration-3000 ease-in-out active:scale-95"
                    >
                        {isExpanded ? '... Show less' : '... Show more'}
                    </button>
                )}
            </div>
        );
    };
    const MobileRemarks = ({ text }) => {

        const [show, setShow] = useState(false);

        if (!text) {
            return <p className="text-gray-500">N/A</p>;
        }

        const longText = text.length > 80;

        return (

            <div className="w-full min-w-0 overflow-hidden">

                <p
                    className={`
                        text-sm
                        text-gray-700
                        break-all
                        overflow-hidden
                        ${show ? "" : "line-clamp-2"}
                    `}
                >
                    {text}
                </p>

                {longText && (

                    <button
                        type="button"
                        onClick={() => setShow(!show)}
                        className="mt-1 text-xs text-blue-600 font-semibold"
                    >
                        {show ? "Read Less" : "Read More"}
                    </button>

                )}

            </div>

        );
    };
    const gridHeaders = ['Name', 'Email Id', 'Remarks', 'Inquiry Date', 'Action'];

    return (
        <div className="p-3 sm:p-5 md:p-6 bg-[#F8FAFC] min-h-screen w-full flex flex-col items-center font-sans">
            
            {/* Constrained layout grid framework sizing proportional boundaries optimized cleanly */}
            <div className="w-full max-w-screen-xl mx-auto flex flex-col space-y-4 px-2 overflow-x-hidden">
                
                {/* ─── BLOCK 1: WIREFRAME PAGE HEADING TITLE ─── */}
                <div className="w-full   py-3.5 text-center rounded-lg ">
                    <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-light text-gray-700 mb-8 tracking-tight">
                        Enquiry Details
                    </h2>
                </div>

                {/* ─── BLOCK 2: DYNAMIC FILTER TOOLBAR CONTAINER INJECTED BY TABLECONTAINER ─── */}

                {/* ─── BLOCK 3: CORE RENDER PRESENTATION DATA PRESENTATION GRID ─── */}
                <div className="hidden md:block overflow-x-auto">
                <div className="hidden md:block">
                <TableContainer
                    columns={['Name', 'Email Id', 'Remarks', 'Inquiry Date', 'Action']}
                    apiUrl="admin/enquiry-details/"
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery} 
                    searchPlaceholder="Filter contact inquiries by name, email or remarks..."
                    renderRow={(item, index, srNo, formatCurrency, refreshTable) => (
                        <tr key={item.contactusid || index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors h-auto text-gray-700 text-xs font-medium bg-white">
                            <td className="p-3 border-r bg-gray-50/50 font-bold text-gray-400 w-[6%] text-center">{srNo}</td>
                            <td className="p-3 border-r text-left pl-5 w-[18%] font-medium text-gray-700">{item.name || 'N/A'}</td>
                            <td className="p-3 border-r text-left pl-5 w-[22%] text-indigo-900 font-normal lowercase break-all">{item.email || 'N/A'}</td>
                            <td className="p-0 border-r w-[44%]"><ExpandedRemarksCell text={item.remarks} /></td>
                            <td className="p-3 border-r font-medium text-gray-600 w-[12%] text-center whitespace-nowrap">{item.inquiry_date || 'N/A'}</td>
                            <td className="w-[10%] p-0">
                                <div className="flex items-center justify-center h-[42px]">
                                    <button onClick={() => handleRecordDeleteTrigger(item.contactusid, refreshTable)} className="text-gray-400 hover:text-red-600 border-none bg-transparent cursor-pointer transition-all">
                                        <FaTrash size={15} />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    )}
                />
                </div>
                </div>
                <div className="md:hidden mt-4">

                <input
                    type="text"
                    value={searchQuery}
                    placeholder="Search enquiry..."
                    onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setMobilePage(1);
                    }}
                    className="w-full border rounded-lg p-3 text-sm outline-none"
                />

                </div>
                <div className="md:hidden w-full min-w-0 space-y-4 mt-4 px-2 overflow-x-hidden">

                {
                loadingCards ? (

                <div className="text-center py-10">

                Loading...

                </div>

                ) : list.length === 0 ? (

                <div className="text-center py-10 text-gray-500">

                No Record Found

                </div>

                ) : (

                list.map((item) => (

                <div
                key={item.contactusid}
                className="
                w-full
                max-w-full
                min-w-0
                overflow-hidden

                flex
                flex-col

                rounded-xl
                border
                border-gray-200

                bg-white

                shadow-sm

                px-4
                py-4

                box-border
                
                ">

                <div
                    className="
                        w-full
                        min-w-0
                        overflow-hidden
                        space-y-3
                    "
                >

                <div className="w-full min-w-0 overflow-hidden">

                <p className="font-bold text-[#032167] text-[15px]">
                Name
                </p>

                <p
                className="
                font-bold
                text-[#032167]
                break-all
                max-w-full
                "
                >
                {item.name}
                </p>

                </div>

                <div className="w-full min-w-0 overflow-hidden">

                <p className="text-sm break-all text-gray-700">
                Email
                </p>

                <p
                className="
                text-sm
                text-gray-700
                break-all
                overflow-hidden
                max-w-full
                "
                >
                {item.email}
                </p>

                </div>

                <div className="w-full min-w-0 overflow-hidden">

                <p className="text-xs text-gray-500">
                    Remarks
                </p>

                <MobileRemarks
                    text={item.remarks}
                />
                </div>

                <div className="w-full min-w-0 overflow-hidden">

                <p className="text-xs text-gray-500">
                Inquiry Date
                </p>

                <p className="font-medium">
                {item.inquiry_date}
                </p>

                </div>

                <div className="border-t pt-3 mt-2 flex justify-end items-center">

                <button
                onClick={() =>
                handleRecordDeleteTrigger(
                item.contactusid,
                window.activeTableRefresh
                )
                }
                className="text-red-600 hover:text-red-800">

                <FaTrash size={18}/>

                </button>

                </div>

                </div>

                </div>

                ))

                )}

                
                <div className="md:hidden flex justify-between items-center mt-5">

                <button
                disabled={mobilePage===1}
                onClick={() => setMobilePage(p => p - 1)}
                className="px-4 py-2 border rounded disabled:opacity-40">

                Previous

                </button>

                <span className="text-sm font-semibold">

                Page {mobilePage} of {Math.max(1, Math.ceil(totalCount / pageSize))}

                </span>

                <button
                disabled={
                mobilePage >= Math.max(
                1,
                Math.ceil(totalCount / pageSize)
                )
                }
                onClick={() => setMobilePage(p => p + 1)}
                className="px-4 py-2 border rounded disabled:opacity-40">

                Next

                </button>

                </div>
                </div>
                {/* <div className="block md:hidden space-y-4">
                    {paginatedData.map((item, index) =>
                        renderCard(
                            item,
                            index,
                            startIndex + index + 1,
                            // formatCurrency,
                            fetchData
                        )
                    )}
                </div> */}

            </div>
        </div>
    );
};

export default EnquiryDetails;
